import { atom } from "recoil";

// The state for requesting an update on EnelX's summary
export const STATE_SUMMARY_UPDATING = atom<boolean>({
    key: 'state-summary-updating',
    default: false
});

